import type { ObjectListHeightMode } from '@frontend/components/list';

/**
 * When nested under shrink height mode (e.g. ObjectDetail), default stacked lists to
 * `maxHeight` unless the caller already set `defaultHeight` or `maxHeight`.
 */
export const resolveTableHeightProps = (
    heightMode: ObjectListHeightMode,
    tableProps?: { defaultHeight?: boolean; maxHeight?: boolean }
): { maxHeight: true } | undefined => {
    if (heightMode === 'shrink' && tableProps?.defaultHeight !== true && tableProps?.maxHeight == null) {
        return { maxHeight: true };
    }
    return undefined;
};
